export const BEST_PRICE_GUARANTEE_TITLE = "Price Match Guarantee";
export const BEST_PRICE_GUARANTEE_SUBTITLE = "Terms and Conditions";
